export const steps = {
    intro: 1,
    confirmInformation: 2,
    success: 3,
};
